module.exports = __webpack_public_path__ + "static/media/ig.9721d7b7.png";